import type {
  RecurringFrequency,
  RecurringLineItemTemplate,
} from "../../types/billing";
export function recurringTotals(
  amount: number,
  items: RecurringLineItemTemplate[],
) {
  const subtotal = items.length
    ? items.reduce(
        (sum, item) =>
          sum +
          Math.round(Number(item.quantity) * Number(item.unit_price) * 100) /
            100,
        0,
      )
    : amount;
  const tax = items.reduce(
    (sum, item) =>
      sum +
      ((Math.round(Number(item.quantity) * Number(item.unit_price) * 100) /
        100) *
        Number(item.tax_rate || 0)) /
        100,
    0,
  );
  return { subtotal, tax, total: subtotal + tax };
}
export function upcomingDates(
  start: string,
  frequency: RecurringFrequency,
  interval: number,
  end?: string | null,
  limit = 4,
) {
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(start) ||
    !Number.isInteger(interval) ||
    interval < 1
  )
    return [];
  const date = new Date(`${start}T12:00:00Z`);
  const result: string[] = [];
  for (
    let n = 0;
    n < Math.min(4, limit) && Number.isFinite(date.getTime());
    n++
  ) {
    const value = date.toISOString().slice(0, 10);
    if (end && value > end) break;
    result.push(value);
    if (frequency === "weekly" || frequency === "biweekly")
      date.setUTCDate(
        date.getUTCDate() + 7 * interval * (frequency === "biweekly" ? 2 : 1),
      );
    else {
      const months =
        interval *
        ({ monthly: 1, custom: 1, quarterly: 3, semiannually: 6, annually: 12 }[
          frequency
        ] || 1);
      const day = date.getUTCDate();
      date.setUTCDate(1);
      date.setUTCMonth(date.getUTCMonth() + months);
      date.setUTCDate(
        Math.min(
          day,
          new Date(
            Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0),
          ).getUTCDate(),
        ),
      );
    }
  }
  return result;
}
